import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { LOGOUT_PATH, REDIRECT_AFTER_LOGIN_KEY } from '@/config';
import { useGetMeQuery } from '@/store/services/authApi';

const APP_PATH_PREFIX = '/app';

const isSafeRedirectPath = (value) => {
    if (typeof value !== 'string' || !value.startsWith(APP_PATH_PREFIX)) return false;
    const nextChar = value[APP_PATH_PREFIX.length];
    return nextChar === undefined || nextChar === '/' || nextChar === '?' || nextChar === '#';
};

const AuthInitializer = ({ children }) => {
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const isLogout = pathname === LOGOUT_PATH;
    const { isSuccess } = useGetMeQuery(undefined, { skip: isLogout });

    useEffect(() => {
        if (isSuccess) {
            const redirectTo = localStorage.getItem(REDIRECT_AFTER_LOGIN_KEY);
            if (isSafeRedirectPath(redirectTo)) {
                localStorage.removeItem(REDIRECT_AFTER_LOGIN_KEY);
                navigate(redirectTo, { replace: true });
            }
        }
    }, [isSuccess, navigate]);

    return isSuccess || isLogout ? children : null;
};

export { AuthInitializer };
